import { keyMirror } from 'utils/keyMirror';

export const ActionTypes = keyMirror(
  {
    SET_COUNTRY_ABBREVIATIONS: null,
  },
  'CountryAbbreviations',
);
